import { MutableRefObject } from 'react';
import { useSelfUpdatingRef } from '@hotelplan/libs.hooks-react';
import { IWishlistOfferManaging } from 'components/domain/wishlist/utils';
import useWishlistCacheManage from './useWishlistCacheManage';

export default function useWishlistOfferManage(): MutableRefObject<IWishlistOfferManaging> {
  const cacheHandlers = useWishlistCacheManage();
  return useSelfUpdatingRef(cacheHandlers);
}
